'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.error = exports.success = exports.start = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The start action for the perform reducer
 * @param  {Immutable.Map} state - current reducer state
 * @param  {Object} action - action object
 *
 * @return {Immutable.Map} - updated state
 */
var start = exports.start = function start(state, action) {
	//console.log('start[state]:', state);
	//console.log('start[action]:', action);

	return state.withMutations(function (map) {
		if (action.isAsync) {
			map.mergeIn(['instances', action.instance, 'additionalData'], _immutable2.default.fromJS(_extends({}, action.additionalData, {
				error: false,
				errorMessage: null,
				isSaving: true,
				isFetching: false,
				isFetchingSingle: false
			})));
		}
	});
};

/**
 * The success action for the update reducer
 * @param  {Immutable.Map} state - current reducer state
 * @param  {Object} action - action object
 *
 * @return {Immutable.Map} - updated state
 */
var success = exports.success = function success(state, action) {
	//console.log('success[state]:', state);
	//console.log('success[action]:', action);
	//console.log('success[responseData]:', action.responseData);

	if (Array.isArray(action.responseData)) {
		//console.log('isArray');
		action.responseData = (0, _immutable.List)(_immutable2.default.fromJS(action.responseData)); //Immutable.fromJS()
		//console.log(action.responseData);
	} else {
			//console.log('is not Array');
		}

	if (_immutable.List.isList(action.responseData)) {
		//console.log('isList');
		//console.log(action.responseData);	 

		// Get the response data
		var responseData = action.responseData ? _immutable2.default.fromJS(action.responseData) : (0, _immutable.Map)();

		responseData.map(function (responseRecord) {

			state = state.withMutations(function (map) {

				var uid = responseRecord.get(action.uidField).toString();
				var previousRecord = map.getIn(['raw', uid]);

				if (previousRecord) {
					// UPDATE PREVIOUS
					// Success responseData should take precedence over all other changes so we
					// merge that into the updated record, then we merge the updatedRecord into existing raw data
					var record = map.getIn(['raw', uid], (0, _immutable.Map)()).merge(previousRecord).merge(responseRecord);
					//console.log('record', record);

					// Update the record in raw
					var updatedRecordTuple = (0, _immutable.Map)([[uid, record]]);
					map.set('raw', state.get('raw').merge(updatedRecordTuple));
				} else {
					// CREATE NEW
					// Add new record to raw using permanent uid
					var newRecord = (0, _immutable.Map)([[uid, responseRecord]]);
					map.set('raw', state.get('raw').merge(newRecord));

					// Add new record to instance array using permanent uid
					var instanceData = map.getIn(['instances', action.instance, 'data'], (0, _immutable.List)());
					// Check if key already present in instance
					if (!(instanceData.indexOf(uid) !== -1)) {
						map.setIn(['instances', action.instance, 'data'], instanceData.push(uid));
					}
					// OLD method
					//map.setIn(['instances', action.instance, 'data'], map.getIn(['instances', action.instance, 'data']).push(uid));

					// UPDATE TOTAL COUNT FOR THIS INSTANCE
					map.setIn(['instances', action.instance, 'additionalData', 'total'], map.getIn(['instances', action.instance, 'additionalData', 'total']) + 1);
				}
			});
		});

		state = state.mergeIn(['instances', action.instance, 'additionalData'], _immutable2.default.fromJS(_extends({}, action.additionalData, {
			error: false,
			errorMessage: null,
			isSaving: false
		})));

		return state;
	} else {

		var uid = action.record.get(action.uidField).toString();

		return state.withMutations(function (map) {
			// Get the pending record
			var updatedRecord = map.getIn(['pendingRaw', uid], (0, _immutable.Map)());
			// Get the response data
			var responseData = action.responseData ? _immutable2.default.fromJS(action.responseData) : (0, _immutable.Map)();

			// Success responseData should take precedence over all other changes so we
			// merge that into the updated record, then we merge the updatedRecord into existing raw data
			var record = map.getIn(['raw', uid], (0, _immutable.Map)()).merge(updatedRecord).merge(responseData);

			// Update the record in raw
			var updatedRecordTuple = (0, _immutable.Map)([[uid, record]]);
			map.set('raw', state.get('raw').merge(updatedRecordTuple));

			// Remove the item from pendingRaw
			map.removeIn(['pendingRaw', uid]);

			// Remove uid from pending.update
			var pendingUpdate = map.getIn(['pending', 'update'], (0, _immutable.List)());
			var uidIndexInPendingUpdate = pendingUpdate.indexOf(uid);
			map.removeIn(['pending', 'update', uidIndexInPendingUpdate]);

			map.mergeIn(['instances', action.instance, 'additionalData'], _immutable2.default.fromJS(_extends({}, action.additionalData, {
				error: false,
				errorMessage: null,
				isSaving: false
			})));
		});
	}
};

/**
 * The error action for the perform reducer
 * Reverts store change on failure
 * @param  {Immutable.Map} state - current reducer state
 * @param  {Object} action - action object
 *
 * @return {Immutable.Map} - updated state
 */
var error = exports.error = function error(state, action) {
	//console.log('error[state]:', state);
	//console.log('error[action]:', action);

	state = state.mergeIn(['instances', action.instance, 'additionalData'], _immutable2.default.fromJS(_extends({}, action.additionalData, {
		error: true,
		errorMessage: action.responseData,
		isSaving: false
	})));

	return state;
};

exports.default = {
	start: start,
	success: success,
	error: error
};